import "../css/Footer.css";

export default function Footer() {
  return (
    <footer>
      <a
        href="https://github.com/chiarastef/react-weather-website"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code
      </a>{" "}
      by Chiara Stefanelli
    </footer>
  );
}
